import * as React from "react";

import { style, MyIconProps } from "./MyIcons";

export const DoorHandleLock = (props: MyIconProps): React.ReactElement => {
  return (
    <svg
      ref={props.elementRef}
      className={props.className}
      style={{ ...style(props), ...props.style }}
      viewBox="0 0 24 24"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.221 12C10.672 12.61 9.885 13 9 13C7.167 13 5.718 11.356 6.047 9.461C6.258 8.249 7.255 7.258 8.467 7.046C9.566 6.855 10.564 7.27 11.221 8H20C20.552 8 21 8.448 21 9V11C21 11.552 20.552 12 20 12H11.221Z"
      />
      <path d="M15 12V19C15 20.105 14.105 21 13 21H5C3.895 21 3 20.105 3 19V5C3 3.895 3.895 3 5 3H13C14.105 3 15 3.895 15 5V8" />
      <path d="M6 16.99C5.997 16.99 5.995 16.992 5.995 16.995C5.995 16.998 5.997 17 6 17C6.003 17 6.005 16.998 6.005 16.995C6.005 16.992 6.003 16.99 6 16.99" />
      <path d="M9.005 16.99C9.002 16.99 9 16.992 9 16.995C9 16.998 9.003 17 9.005 17C9.008 17 9.01 16.998 9.01 16.995C9.01 16.992 9.008 16.99 9.005 16.99" />
      <path d="M12 16.99C11.997 16.99 11.995 16.992 11.995 16.995C11.995 16.998 11.997 17 12 17C12.003 17 12.005 16.998 12.005 16.995C12.005 16.992 12.003 16.99 12 16.99" />
    </svg>
  );
};
